// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "21b273d5","6611": "acceaf1a","8150": "3f898976",}[chunkId] + ".css"
}